export default "__VITE_ASSET__Cy7RN5W9__"